import React from "react";
import "./ServicesCart.css";
import { Link } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";

export default function ServicesCart({ img, text1, text2, text3, text4, text5, text6 }) {
  return (
    <div className="ServicesCart-Body">
      <img src={img} alt="Icon" className="ServicesCart-Icon" />
      <Link to="/service" className="ServicesCart-Link">
        {text1}
      </Link>
      <div className="ServicesCart-Box">
        <div className="ServicesCart-Div">
          <DoubleRightOutlined />
          <p className="ServicesCart-Text">{text2}</p>
        </div>
        <div className="ServicesCart-Div">
          <DoubleRightOutlined />
          <p className="ServicesCart-Text">{text3}</p>
        </div>
        <div className="ServicesCart-Div">
          <DoubleRightOutlined />
          <p className="ServicesCart-Text">{text4}</p>
        </div>
        <div className="ServicesCart-Div">
          <DoubleRightOutlined />
          <p className="ServicesCart-Text">{text5}</p>
        </div>
        <div className="ServicesCart-Div">
          <DoubleRightOutlined />
          <p className="ServicesCart-Text">{text6}</p>
        </div>
      </div>
    </div>
  );
}
